
import Vue from 'vue'
import { mdiEmoticonDeadOutline } from '@mdi/js'
export default Vue.extend({
	data(){
		return {
			mdiEmoticonDeadOutline,
		}
	}
})
